import { create } from 'zustand';
import i18n from 'i18n';
import { AuthApi, ResendCodeResponse, RestApiError, StatusCodeEnum } from '@shared/api';
import type { BaseReturn } from '@shared/types';
import { AuthUtils } from '@shared/utils';

interface UseResendCodeStore {
  loading: boolean;
  data: ResendCodeResponse | null;
  error?: string | null;
  resendCode: () => Promise<BaseReturn<ResendCodeResponse | null>>;
  clear: () => void;
}

export const useResendCodeStore = create<UseResendCodeStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  resendCode: async () => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await AuthApi.loginResendCode();
      AuthUtils.setTempToken(result.loginToken);
      set({ loading: false, data: result ?? null });
      return { loading: false, data: result ?? null };
    } catch (e) {
      const restError = e as RestApiError;

      let errorMessage = 'Something went wrong, try again';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_UNAUTHORIZED:
          errorMessage = typeof restError.data === 'string' ? restError.data : 'Invalid code or password';
          break;
      }

      window.location.href = '/';
      const error = i18n.t(`errors.api.${errorMessage}`, errorMessage);
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
